import enLang from './locales/en_US/en-US';
import jpLang from './locales/ja_JP/ja-JP';

const AppLocale = {
  ja: jpLang,
  en: enLang,
};

export default AppLocale;
